import PropTypes from 'prop-types';
import NormalNode from './nodes/NormalNode';
import ConditionNode from './nodes/ConditionNode';
import ApprovalNode from './nodes/ApprovalNode';
import TriggerNode from './nodes/TriggerNode';
import NodeSpacer from './NodeSpacer';
import { lastShowBlankNode, showBlankNode } from './utils';
import BlankNode from './nodes/BlankNode';
import EndNode from './nodes/EndNode';

function NodeRenderer(props) {
  const { keyPath, nodeList = [] } = props;

  const nodes = [];

  const isTopLevel = keyPath.length === 1;

  if (!isTopLevel) {
    nodes.push(
      <NodeSpacer
        key={`${keyPath},spacer`}
        keyPath={keyPath}
        canAdd={!showBlankNode(nodeList, 0)}
      />,
    );
  }

  const lastHasBlankNode = !isTopLevel && lastShowBlankNode(nodeList);

  nodeList.forEach((node, index) => {
    const { nodeTypeToken } = node;

    const currentKeyPath = keyPath.concat(index);

    if (nodeTypeToken === 'condition') {
      if (!(isTopLevel && index === 0) && showBlankNode(nodeList, index)) {
        // condition node 本身不显示，如果上一个节点同时也是分支节点，则需要一个点来标注连线位置
        nodes.push(
          <BlankNode
            key={`${currentKeyPath},blank`}
            id={`${currentKeyPath},blank`}
            keyPath={keyPath.concat(index - 1)}
            canAdd={true}
          />,
        );
        nodes.push(<NodeSpacer key={`${currentKeyPath},blank,spacer`} />);
      }
      nodes.push(<ConditionNode key={node.id} {...node} keyPath={currentKeyPath} />);
    } else if (nodeTypeToken === 'approval') {
      nodes.push(<ApprovalNode key={node.id} {...node} keyPath={currentKeyPath} />);
    } else {
      nodes.push(<NormalNode key={node.id} {...node} keyPath={currentKeyPath} />);
    }

    nodes.push(
      <NodeSpacer
        key={`${currentKeyPath},spacer`}
        keyPath={currentKeyPath}
        // 如果后续是 blankNode，那么 AddButton 显示在 BlankNode 里面会更好看
        canAdd={
          !(index === nodeList.length - 1 && lastHasBlankNode) &&
          !showBlankNode(nodeList, index + 1)
        }
      />,
    );
  });

  if (lastHasBlankNode) {
    nodes.push(
      <BlankNode
        key={`${keyPath},blank`}
        id={`${keyPath},blank`}
        keyPath={keyPath.concat(nodeList.length)}
        canAdd={true}
      />,
    );
  }

  if (!isTopLevel && lastHasBlankNode) {
    nodes.push(<NodeSpacer key={`${keyPath},blank,spacer`} />);
  }

  if (isTopLevel) {
    nodes.unshift(<NodeSpacer key="trigger-node-spacer" keyPath={keyPath} canAdd={true} />);
    nodes.unshift(<TriggerNode key="trigger-node" keyPath={keyPath} />);
    nodes.push(<EndNode key="end-node" />);
  }

  return nodes;
}

NodeRenderer.propTypes = {
  keyPath: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  nodeList: PropTypes.arrayOf(
    PropTypes.shape({
      nodeTypeToken: PropTypes.string,
    }),
  ),
};

export default NodeRenderer;
